// 🔎 화면 배율 잠깐 표시 — 브라우저 확대/축소처럼 조작하는 동안 우측 상단에 '90%' 를 띄웠다가, 마지막 조작 1.2초 뒤 사라진다
//   (2026-10-13 형 "ctrl+휠로 화면 크기 줄일 때 웹처럼 %가 나왔다가 없어지게"). 신호는 uiScale.flashZoom(ZOOM_FLASH_EVENT) —
//   Ctrl+휠·Ctrl+=/−/0(App.tsx)·안드 볼륨키(tpt-app-scale-bump)만 보낸다. 클릭을 가로채지 않게 pointer-events 없음.
import { useEffect, useRef, useState } from 'react';
import { ZOOM_FLASH_EVENT } from '../../api/uiScale';

const SHOW_MS = 1200;

export default function ZoomIndicator() {
	const [pct, setPct] = useState<number | null>(null);
	const [visible, setVisible] = useState(false);
	const timer = useRef<number | null>(null);
	useEffect(() => {
		const onFlash = (e: Event) => {
			const v = Number((e as CustomEvent<number>).detail);
			if (!Number.isFinite(v)) return;
			setPct(v); setVisible(true);
			if (timer.current !== null) window.clearTimeout(timer.current);
			timer.current = window.setTimeout(() => setVisible(false), SHOW_MS);
		};
		window.addEventListener(ZOOM_FLASH_EVENT, onFlash);
		return () => {
			window.removeEventListener(ZOOM_FLASH_EVENT, onFlash);
			if (timer.current !== null) window.clearTimeout(timer.current);
		};
	}, []);
	if (pct === null) return null;
	return (
		<div role="status" aria-live="polite" data-testid="zoom-indicator"
			className={`pointer-events-none fixed right-4 top-4 z-[2100] rounded-full bg-slate-900/80 px-3.5 py-1.5 text-ui-sm font-bold tabular-nums text-white shadow-lg transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`}>
			{pct}%
		</div>
	);
}
